import fetchAPI from '../../../utils/fetchAPI';
import { apiUrl } from '../../../constants/global';
import { TLatLongClient } from 'types/TLatLong';

const getCenter = async ({ postcode }: { postcode: string }): Promise<TLatLongClient> => {
  try {
    const response = await fetchAPI({
      url: `${apiUrl}center?postcode=${encodeURIComponent(postcode)}`,
    });

    return {
      response,
    };
  } catch (error: any) {
    return {
      error: {
        code: error.code,
      },
    };
  }
};

export default getCenter;
